import { Button, Card, Descriptions, Result, Spin, message } from 'antd';
import * as moment from 'moment';
import { React, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import AnulacionForm from '../../components/AnulacionForm';
import ResponsiveContainer from '../../components/ResponsiveContainer';
import { DatosProducto } from '../../components/SolicitudView';
import {
  COMENTARIOS_ADICIONALES_ANULACION,
  OTROS_MOTIVOS_ANULACION
} from '../../constants';
import { errorHandler } from '../../utils';
import { instanceRef } from '../../utils/axios';
import { formatoMonedaGenerico } from '../../utils/converters';

function PolizaAnulacion() {
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const token = location.pathname.split('/').pop();
  const history = useHistory();
  const [fields, setFields] = useState();
  const [solicitud, setSolicitud] = useState();
  useEffect(() => {
    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetch = async () => {
    setLoading(true);
    try {
      const polizaResponse = await instanceRef.instance.get(
        `/poliza/${token}/detalle-web`
      );
      setFields(polizaResponse.data.data);
      const solicitudResponse = await instanceRef.instance.get(
        `/solicitud/${polizaResponse.data.data.solicitud.token}`
      );
      setSolicitud(solicitudResponse.data.data);
    } catch (error) {
      message.error('Error al obtener datos de la póliza');
    }
    setLoading(false);
  };

  const handleConfirm = async (submitData) => {
    try {
      setLoading(true);
      const payload = {
        option: submitData.option,
        comments: submitData[COMENTARIOS_ADICIONALES_ANULACION.codigo],
        otrosMotivos: submitData[OTROS_MOTIVOS_ANULACION.codigo]
      };
      const response = await instanceRef.instance.post(
        `poliza/${token}/anulacion-poliza`,
        payload
      );
      setLoading(false);
      if (response.data.data) {
        const { data } = response.data;
        message.success(`${data}`);
        setIsConfirmed(true);
      } else {
        message.warning('Error en la comunicacion con el servidor');
        return;
      }
    } catch (err) {
      setLoading(false);
      errorHandler(err);
    }
  };

  const handleCancel = () => {
    history.push('/');
  };
  return (
    <>
      <ResponsiveContainer size="large">
        <Spin spinning={loading}>
          {isConfirmed ? (
            <Card
              style={{
                textAlign: 'left',
                overflow: 'visible',
                whiteSpace: 'normal'
              }}
            >
              <Result
                status="success"
                title="¡Anulación de póliza exitosa!"
                subTitle={`La póliza nro. ${fields.seccion}-${fields.numero}-${fields.endoso} ha sido anulada`}
                extra={[
                  <Button
                    type="primary"
                    key="console"
                    onClick={() => history.push('/')}
                  >
                    Ir al inicio
                  </Button>
                ]}
              />
            </Card>
          ) : (
            <Card
              title="Verifique los datos de la póliza a anular"
              style={{
                textAlign: 'left'
              }}
            >
              {fields && solicitud && (
                <div>
                  <Descriptions
                    title={`Número de póliza.:  ${fields.seccion}-${fields.numero}-${fields.endoso}`}
                    style={{ textAlign: 'left', paddingBottom: 40 }}
                    column={{ md: 2, sm: 1, xs: 1 }}
                    bordered
                    size="small"
                  >
                    <Descriptions.Item label="Fecha de emisión" span={2}>
                      {fields.fecha_emision &&
                        moment(fields.fecha_emision).format('DD/MM/YYYY')}
                    </Descriptions.Item>
                    <Descriptions.Item label="Inicio de Vigencia">
                      {fields.fecha_inicio_vigencia &&
                        moment(fields.fecha_inicio_vigencia).format(
                          'DD/MM/YYYY'
                        )}
                    </Descriptions.Item>
                    <Descriptions.Item label="Fin de Vigencia">
                      {fields.fecha_fin_vigencia &&
                        moment(fields.fecha_fin_vigencia).format('DD/MM/YYYY')}
                    </Descriptions.Item>
                    <Descriptions.Item label="Total de cuotas">
                      {fields.total_cuotas}
                    </Descriptions.Item>
                    <Descriptions.Item label="Premio">
                      {formatoMonedaGenerico(fields.moneda, fields.premio)}
                    </Descriptions.Item>
                  </Descriptions>
                  <DatosProducto fields={solicitud} />
                  <Card
                    title={`Confirmar anulación de póliza número ${fields.seccion}-${fields.numero}-${fields.endoso}`}
                    style={{ textAlign: 'left' }}
                  >
                    <AnulacionForm
                      confirmar={handleConfirm}
                      cancelar={handleCancel}
                      loading={loading}
                      style={{ textAlign: 'left', width: '50%' }}
                    />
                  </Card>
                </div>
              )}
            </Card>
          )}
        </Spin>
      </ResponsiveContainer>
    </>
  );
}
export default PolizaAnulacion;
